module.exports = "/fonts/fa-solid-900.svg?b557f56e367e59344ca95f9d1fb44352";